import { useRef, useState, useEffect } from "react"
import { playIcon } from "../../icons"
import "./case-study-hero.component.css"
import { Remarkable } from "remarkable"
import VideoModalComponent from "../video-modal/video-modal.component"
import StrapiImageComponent from "../strapi-image/strapi-image.component"
import { toCdnUrl } from "../../utils/cdn.util"

const CaseStudyHeroComponent = (props) => {
  const { Heading, Copy, Media, id } = props
  const [showModal, setShowModal] = useState()
  const [isVisible, setIsVisible] = useState(false)
  const heroRef = useRef(null)
  const videoElRef = useRef()
  const isImage = Media?.data.attributes.mime.indexOf("image") > -1
  const md = new Remarkable()

  useEffect(() => {
    const el = heroRef.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(el)
        }
      },
      { threshold: 0.2 },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const handleShowVideo = (c) => {
    setShowModal({
      id: id,
      src: toCdnUrl(Media.data.attributes.url),
      UseLandscapeAspectRatio: true,
    })

    videoElRef.current.pause()
  }

  const handleCloseVideo = () => {
    setShowModal(false)
    videoElRef.current.play()
  }

  return (
    <div
      ref={heroRef}
      className={`dagger-case-study-hero ${isVisible ? "dagger-slide-in-visible" : "dagger-slide-in-hidden"}`}
    >
      {showModal && (
        <VideoModalComponent {...showModal} onClose={handleCloseVideo} />
      )}
      <div className="dagger-169">
        {isImage && <StrapiImageComponent attributes={Media?.data.attributes} alt={Heading} />}
        {!isImage && (
          <>
            <div className="video-play-icon">{playIcon}</div>
            <video
              ref={videoElRef}
              src={toCdnUrl(Media?.data.attributes.url)}
              autoPlay
              muted
              loop
              playsInline
              onClick={handleShowVideo}
            />
          </>
        )}
      </div>
      {Heading && <h2>{Heading}</h2>}
      {Copy && (
        <div
          className="dagger-case-study-hero-copy"
          dangerouslySetInnerHTML={{ __html: md.render(Copy) }}
        />
      )}
    </div>
  )
}

export default CaseStudyHeroComponent
